import { useMutation } from '@tanstack/react-query'
import { AxiosInstance } from 'axios'
import { httpClient } from 'config/axios'
import { parseCookies } from 'nookies'
import { endpoints } from 'services/image/endpoints'
import { UserProfileImageResponse } from 'services/image/types'
import buildUrl from 'utilities/buildUrl'

interface ImageDriver {
  getImage(imageId: string): Promise<string>
}

export class ImageDriverImpl implements ImageDriver {
  public constructor(private readonly HttpClient: AxiosInstance = httpClient) {}

  public async getImage(imageId: string): Promise<string> {
    const response = await this.HttpClient.get(`/image/${imageId}/file`, {
      responseType: 'blob',
    })

    // eslint-disable-next-line
    return URL.createObjectURL(response.data)
  }
}

export default new ImageDriverImpl()

async function updateUserProfileImage(
  image: File,
): Promise<UserProfileImageResponse> {
  const { userId } = parseCookies()

  const extension = image.type.split('/')[1] || 'jpg'
  const renamedFile = new File([image], `originalname.${extension}`, {
    type: image.type,
  })

  const data = new FormData()
  data.append('imageFile', renamedFile)
  data.append('userId', userId)

  const result = await httpClient.post(
    buildUrl({
      route: endpoints.changeImageProfile,
      params: { userId },
    }),
    data,
    {
      headers: {
        accept: 'application/json',
        'Content-Type': `multipart/form-data`,
      },
    },
  )

  return result.data
}

export const useChangeProfileImage = () => {
  return useMutation({
    mutationKey: ['userId'],
    mutationFn: async (image: File) => {
      const response = await updateUserProfileImage(image)
      return response
    },
  })
}
